/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import styled from "styled-components";

import { APP_COLORS } from "../../../common/Constants";
import LabelDetailItem from "./LabelDetailItem";

const CompanyDetail = (props) => {
    const { company } = props;

    const statisticsSplit = (value) => {
        const split = value.split(":");
        return split[1] || null;
    }

    const showContent = (company) => {
        if (
            company.indicators?.markets ||
            company.activity?.jobProjectTypes ||
            company.services ||
            company.statistics?.projectValue ||
            company.statistics?.salesRange ||
            company.addressLocMsa ||
            company.licenses?.licenses ||
            company.affiliations
        ) return true;
    }

    if (showContent(company)) {
        return (
            <MainContainer>
                {company.indicators?.markets && (
                    <LabelDetailItem label={'Markets :'} description={company.indicators?.markets} />
                )}
                {company.activity?.jobProjectTypes && (
                    <LabelDetailItem label={'Projects :'} description={company.activity?.jobProjectTypes} />
                )}
                {company.services && (
                    <LabelDetailItem label={'Services :'} description={company.services} />
                )}
                {company.statistics?.projectValue && (
                    <LabelDetailItem label={'Project Value :'} description={company.statistics?.projectValue} />
                )}
                {company.statistics?.salesRange && (
                    <LabelDetailItem label={'Revenue :'} description={statisticsSplit(company.statistics?.salesRange)} />
                )}
                {company.addressLocMsa && (
                    <LabelDetailItem label={'MSA :'} description={company.addressLocMsa} />
                )}
                {company.licenses?.licenses && (
                    <LabelDetailItem label={'Licensed :'} description={company.licenses?.licenses} />
                )}
                {company.affiliations && (
                    <LabelDetailItem label={'Associations :'} description={company.affiliations} />
                )}
            </MainContainer>
        )
    }

    return (
        <></>
    );
}

export default CompanyDetail;

const MainContainer = styled.div`
    width: 100%;
  
    padding: 20px 0px;

    border-radius: 4px;
    border: 2px solid ${APP_COLORS['gray-300']}
`;
